import { render } from "./ResetConfirmDialog.vue?vue&type=template&id=12a93442&scoped=true"
import script from "./ResetConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ResetConfirmDialog.vue?vue&type=script&lang=js"

import "./ResetConfirmDialog.vue?vue&type=style&index=0&id=12a93442&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a93442"]])

export default __exports__